import { render, staticRenderFns } from "./Rotate.vue?vue&type=template&id=6208f052&scoped=true&"
import script from "./Rotate.vue?vue&type=script&lang=js&"
export * from "./Rotate.vue?vue&type=script&lang=js&"
import style0 from "./Rotate.vue?vue&type=style&index=0&id=6208f052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208f052",
  null
  
)

export default component.exports